import { Gizmo } from "flowy-3-core";
import { Row } from "antd";
import { conecta26 } from "../../assets/images";

type LoginHeaderProps = {
  gizmo: Gizmo;
};

const LoginHeader = ({ gizmo }: LoginHeaderProps) => {
  return (
    <Row justify={"center"}>
      <img
        src={conecta26}
        alt="Conecta 26"
        style={{
          maxWidth: "100%",
        }}
      />
    </Row>
  );
};

export default LoginHeader;
